import { apiSlice } from '../../../api/apiSlice';
import { EMPLOYEE_PAYRULES_TENURE_DETAILS } from '../../../constants';

export const scorecardPayRulesSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getEmployeePayRuleTenureDetails: builder.query({
            query: (arg: any) => {
                const { employeeNumber, year, month,scorecardVersionId ,scorecardRoleId} = arg;
                return {
                    url: EMPLOYEE_PAYRULES_TENURE_DETAILS,
                    params: { employeeNumber, year, month,scorecardVersionId ,scorecardRoleId },
                };
            },
        }),
    }),
});

export const { useGetEmployeePayRuleTenureDetailsQuery } = scorecardPayRulesSlice;
